import API from "../utils/API";
import adminAPI from "../utils/API/adminAPI";

// ----------------- Button Active Length ------------------//
export const buttonsActiveState = (arr) => {
    let count = 0;
    for (const button of arr) {
        if (button.active) {
            count += 1;
            if (count > 5) {
                button.active = false;
            };
        };
    };
    return arr;
};
// ---------------------------------------------------------//

// ---------------- New Button Options ---------------- //
export const createButtonOptions = () => {
    const socials = [
        {ref: 'email', label: 'Email', name: 'Email', icon: 'fa-solid fa-envelope'},
        {ref: 'phone', label: 'Phone', name: 'Phone', icon: 'fa-solid fa-phone'},
        {ref: 'website', label: 'Website', name: 'Website', icon: 'fa-brands fa-chrome'},
        {ref: 'facebook', label: 'Facebook Handle or Link', name:'Facebook', icon:'fa-brands fa-facebook'},
        {ref: 'instagram', label: 'Instagram Handle or Link', name: 'Instagram', icon: 'fa-brands fa-instagram'},
        {ref: 'linkedin', label: 'LinkedIn Handle or Link', name: 'LinkedIn', icon: 'fa-brands fa-linkedin'},
        {ref: 'pinterest', label: 'Pinterest Handle or Link', name: 'Pinterest', icon: 'fa-brands fa-pinterest'},
        {ref: 'tiktok', label: 'TikTok Handle or Link', name: 'TikTok', icon:'fa-brands fa-tiktok'},
        {ref: 'tumblr', label: 'Tumblr Handle or Link', name: 'Tumblr', icon: 'fa-brands fa-tumblr'},
        {ref: 'twitch', label: 'Twitch Handle or Link', name: 'Twitch', icon: 'fa-brands fa-twitch'},
        {ref: 'twitter', label: 'Twitter Handle or Link', name: 'Twitter', icon: 'fa-brands fa-x-twitter'},
        {ref: 'whatsapp', label: 'WhatsApp', name: 'WhatsApp', icon: 'fa-brands fa-whatsapp'},
        {ref: 'youtube', label: 'YouTube Handle or Link', name: 'YouTube', icon: 'fa-brands fa-youtube'},
    ];

    return socials;
};

export const buttonRefArr = ['facebook', 'instagram', 'linkedin', 'pinterest', 'tiktok', 'tumblr', 'twitch', 'twitter', 'youtube'];

export const getButtonLink = (ref, data) => {
    if ((ref !== 'email' && ref !== 'phone') && (data.includes(`${ref}.com`) || data.includes(`twitch.tv`))) {
        if (ref === 'linkedin') {
            if (!data.includes('http') && !data.includes('.com/in/')) {
                return `https://${data.split('.com/')[0]}.com/in/${data.split('.com/')[1]}`;
            } else if (!data.includes('http') && data.includes('.com/in/')) {
                return `https://${data}`;
            } else if (data.includes('http') && !data.includes('.com/in/')) {
                return `${data.split('.com/')[0]}.com/in/${data.split('.com/')[1]}`;
            } else return data;
        } else {
            if (!data.includes('http')) {
                return `https://${data}`;
            } else return data;
        };
    } else {
        switch (ref) {
            case 'facebook': 
                return `https://www.${ref}.com/${data}`;
            case 'instagram': 
                return `https://www.${ref}.com/${data}`;
            case 'twitter': 
                return `https://www.${ref}.com/${data}`;
            case 'tiktok': 
                return `https://www.${ref}.com/${data.includes('@') ? data : `@${data}`}`;
            case 'linkedin': 
                return `https://www.${ref}.com/in/${data}`;
            case 'youtube': 
                return `https://www.${ref}.com/${data.includes('@') ? data : `@${data}`}`;
            case 'twitch': 
                return `https://www.${ref}.tv/${data}`;
            case 'tumblr': 
                return `https://www.${ref}.com/${data}`;
            case 'pinterest': 
                return `https://www.${ref}.com/${data}`;
            default:
                if ((ref !== 'email' && ref !== 'phone') && !data.includes('http')) {
                    return `https://${data}`;
                } else {
                    return data;
                };
        };
    }; 
};

export const getSocialUserHandle = (ref, data) => {
    switch (ref) {
        case 'facebook':
        case 'instagram':
        case 'tumblr':
        case 'pinterest':
            if (data?.includes('.com/')) {
                return `@${data.split('.com/')[1].split('/')[0]}`;
            } else if (data?.includes('.com')) {
                return data;
            } else {
                return `@${data.split('/')[0]}`;
            };
        case 'youtube':
        case 'tiktok':
        case 'twitter':
            if (data?.includes('.com/')) {
                if (data?.includes('@')) {
                    return data.split('.com/')[1].split('/')[0];
                } else if (!data?.includes('@')) {
                    return `@${data.split('.com/')[1].split('/')[0]}`;
                };
            } else if (data?.includes('.com')) {
                return data;
            } else {
                if (data?.includes('@')) {
                    return data.split('/')[0];
                } else {
                    return `@${data.split('/')[0]}`;
                };
            };
            break;
        case 'linkedin':
            if (data?.includes('.com/in/')) {
                if (data?.includes('.com/in/company/')) {
                    return `@${data.split('/in/company/')[1].split('/')[0]}`
                } else {
                    return `@${data.split('/in/')[1].split('/')[0]}`;
                };
            } else if (data?.includes('.com/company/')) {
                return `@${data.split('/company/')[1].split('/')[0]}`;
            } else if (data?.includes('.com') || data?.includes('.com/in')) {
                return data;
            } else {
                return `@${data.split('/')[0]}`;
            };
        case 'twitch':
            if (data?.includes('.tv/')) {
                return  `@${data.split('.tv/')[1].split('/')[0]}`;
            } else if (data?.includes('.tv')) {
                return data;
            } else {
                return `@${data.split('/')[0]}`;
            };
        default:
            return data;
    };
};
// ------------------------------------------------ //

// ---------------- Save New User Data ---------------- //
export const updateVcardObject = async (data, uid) => {
    try {
        switch (window.location.pathname) {
            case '/settings':
            case '/signup/wizard':
                await API.updateVcardObject(data);
                break;
            case '/admin':
            case '/dashboard':
            case '/dashboard/manage':
                await adminAPI.updateVcardObj(uid, data);
                break;
            default:
                break;
        };
    } catch (err) {
        console.log(err);
    };
};
// ---------------------------------------------- //

// ---------------- Helper Functions ---------------- //

export const getProfilePicLink = (uid) => `https://storage.googleapis.com/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${uid}/profile_image.png?${Date.now()}`;

// ---------------------------------------------- //

export const settingsFunctions = {
    createButtonOptions,
    updateVcardObject,
    buttonsActiveState,
    getButtonLink,
    buttonRefArr,
    getSocialUserHandle,
    getProfilePicLink
};